import styled from 'styled-components';
import { rem, colors, device } from '../lib/global-styles';

export const Button = styled.button`
  color: ${props => (props.dark ? colors.white : colors.primary)};
  background: ${props =>
    props.dark
      ? `linear-gradient(to right, ${colors.gradientEnd}, ${colors.gradientStart})`
      : 'none'};
  padding: ${rem(15)};
  border: ${props => (props.noBorder ? 'none' : `2px solid ${colors.primary}`)};
  border-radius: ${rem(30)};
  display: block;
  margin: auto;
  width: ${props => (props.noWidth ? '' : '90%')};
  font-size: ${rem(14)};
  font-weight: bold;
  margin-bottom: ${rem(20)};
  margin-top: ${rem(10)};

  &:hover {
    background: ${props => (props.dark ? colors.primaryHover : 'none')};
  }

  span {
    background: url(${props => (props.image ? props.image : '')}) no-repeat;
    display: inline-block;
    height: ${rem(16)};
    width: ${rem(19)};
    margin-left: ${rem(8)};
  }

  @media ${device.desktop} {
    width: ${props => (props.noWidth ? '' : `${rem(320)}`)};
    min-width: 150px;
  }
`;
